import { IconStyled, IconStylesProps } from './IconStyles';

export const LockClosed = ({
  size = 'base',
  className = '',
  fill = '',
  hoverCursor,
}: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    fill={fill}
    hoverCursor={hoverCursor}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M54.1538 30H51.6923V20.4587C51.6923 8.98625 43.5188 0 31.9089 0C20.2523 0 12.3077 9.1775 12.3077 20.4587V30H9.84615C4.416 30 0 34.485 0 40V70C0 75.515 4.416 80 9.84615 80H54.1538C59.584 80 64 75.515 64 70V40C64 34.485 59.584 30 54.1538 30ZM17.2308 20.4587C17.2308 11.9363 22.9662 5 31.9089 5C40.7594 5 46.7692 11.79 46.7692 20.4587V30H17.2308V20.4587ZM59.077 70C59.077 72.7562 56.8678 75 54.1539 75H9.84623C7.13238 75 4.92315 72.7562 4.92315 70V40C4.92315 37.2437 7.13238 35 9.84623 35H54.1539C56.8678 35 59.077 37.2437 59.077 40V70ZM32.0001 45C29.2813 45 27.077 47.2387 27.077 50C27.077 51.8462 28.0739 53.44 29.5385 54.3062V62.5C29.5385 63.88 30.6413 65 32.0001 65C33.3588 65 34.4616 63.88 34.4616 62.5V54.3062C35.9262 53.44 36.9231 51.845 36.9231 50C36.9231 47.2387 34.7188 45 32.0001 45Z'
      fill='#8795A1'
    />
  </IconStyled>
);
